module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-Bold.f1eee8cb.ttf";